// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__398O4","label":"CategoryService_label__3sGeF","location":"CategoryService_location__1TBWq"};